// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"Checkbox_checkboxContainer__35jGz","checkMarkContainer":"Checkbox_checkMarkContainer__3F4Fw","checkMark":"Checkbox_checkMark__K_bFO"};